import { render, staticRenderFns } from "./message_channels__list.vue?vue&type=template&id=0f39d7b3"
import script from "./message_channels__list.vue?vue&type=script&lang=js"
export * from "./message_channels__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports